"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParsedNftAccountsByUpdateAuthority = exports.createConnectionConfig = void 0;
// @ts-nocheck
var web3_js_1 = require("@solana/web3.js");
var metaplex_1 = require("./config/metaplex");
var utils_1 = require("./utils");
var createConnectionConfig = function (clusterApi, commitment) {
    if (clusterApi === void 0) { clusterApi = (0, web3_js_1.clusterApiUrl)('mainnet-beta'); }
    if (commitment === void 0) { commitment = 'confirmed'; }
    return new web3_js_1.Connection(clusterApi, commitment);
};
exports.createConnectionConfig = createConnectionConfig;
var getParsedNftAccountsByUpdateAuthority = function (_a) {
    var updateAuthority = _a.updateAuthority, _b = _a.connection, connection = _b === void 0 ? (0, exports.createConnectionConfig)() : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var res, decodedArray, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, connection.getProgramAccounts(new web3_js_1.PublicKey(metaplex_1.METADATA_PROGRAM), {
                            encoding: 'base64',
                            filters: [
                                {
                                    memcmp: {
                                        offset: 1,
                                        bytes: updateAuthority,
                                    },
                                },
                            ],
                        })];
                case 1:
                    res = _c.sent();
                    return [4 /*yield*/, Promise.all(res.map(function (acc) { return (0, utils_1.decodeTokenMetadata)(acc.account.data); }))];
                case 2:
                    decodedArray = _c.sent();
                    return [2 /*return*/, decodedArray];
                case 3:
                    err_1 = _c.sent();
                    console.error(err_1);
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.getParsedNftAccountsByUpdateAuthority = getParsedNftAccountsByUpdateAuthority;
//# sourceMappingURL=getParsedNftAccountsByUpdateAuthority.js.map